import Raven from '../services/raven';

const ravenMiddleware = store => next => action => {
  Raven.captureBreadcrumb({
    message: action.type,
    category: 'redux'
  });

  try {
    return next(action);
  } catch (e) {
    Raven.captureException(e, {
      extra: { SOURCE: 'Redux ravenMiddleware' }
    });
    Raven.showReportDialog({});
  }
};

export default ravenMiddleware;



// WEBPACK FOOTER //
// ./src/store/ravenMiddleware.js